import React from 'react';
import HeroHeader from '../components/hero-header';
import PostPreviews from '../components/post-previews';
import Layout from '../components/shared/layout';

const HomePage = () => {
    return (
        <Layout pageTitle="Home">
            <HeroHeader />
            <PostPreviews />
        </Layout>
    );
};

export default HomePage;
